import React from 'react';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { DEFAULT_COLUMNS } from './InvestmentTable.meta';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';

const MOBILE_HEADERS = ['Name', 'Total G/L'];
const DEFAULT_HEADERS = DEFAULT_COLUMNS.map(({ name }) => name);

export const InvestmentTableEmpty = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <HtmlTable>
      <table>
        <thead>
          <tr>
            {[...(isEmbeddedMobile ? MOBILE_HEADERS : DEFAULT_HEADERS)].map(text => (
              <th key={text}>
                <Text variant="tableHeader">{text}</Text>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td colSpan={[...(isEmbeddedMobile ? MOBILE_HEADERS : DEFAULT_HEADERS)].length}>
              <Text>There is no realized gain/loss information available.</Text>
            </td>
          </tr>
        </tbody>
      </table>
    </HtmlTable>
  );
};
